import { OnboardRole } from "appSettings";

const teamRoles = [
    { roleId: OnboardRole.ACCOUNT_OWNER, label: "Owner", description: "Can perform ALL actions including billing/payments, disable/delete account." },
    { roleId: OnboardRole.TEAM_MEMBER, label: "Member", description: "Can perform all actions EXCEPT billing/payments, disable/delete account, manage team." },
    { roleId: OnboardRole.DEVELOPER, label: "Developer", description: "Can ONLY perform actions under Settings except manage team, disable/delete account." },
];

export default teamRoles;